import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ebed8b8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/draws-type/_draws-type.scss?vue&type=style&index=0&id=6ebed8b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebed8b8",
  null
  
)

export default component.exports